import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import BaseModal from '../BaseModal';
import { allocatePurchaseLineitems } from 'actions/purchases';
import Spinner from 'components/Spinner';
import AllocateLineItemsForm from './AllocateLineItemsForm';

import styles from './styles.module.scss';

class AllocateLineItemsModal extends Component {
  state = {
    loading: false,
    isOpen: false,
  };

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  handleAllocateLineitems = (values) => {
    const { purchaseId, allocatePurchaseLineitems } = this.props;

    this.setState({ loading: true });
    return allocatePurchaseLineitems(purchaseId, values)
      .then(() => {
        this.closeModal();
        toast.success(`Plan lineitems allocated`);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { isOpen, loading } = this.state;

    const initialValues = { is_upcoming: false };

    return (
      <React.Fragment>
        <button className="btn btn-primary mar-b" onClick={this.openModal}>
          Allocate Plan Lineitems
        </button>
        <BaseModal
          isOpen={isOpen}
          title="Allocate Plan Lineitems"
          onClose={this.closeModal}
          className={styles.modal}
          confirmBtnText=""
          cancelBtnText=""
        >
          <AllocateLineItemsForm
            initialValues={initialValues}
            onSubmit={this.handleAllocateLineitems}
          />
          <Spinner showLoader={loading} />
        </BaseModal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  allocatePurchaseLineitems,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AllocateLineItemsModal);
